
import { Modal } from "bootstrap";
import { defineComponent, ref, inject } from "vue";
import { Input } from "@/components/input-elements";
import { PostCodeUpdateFormData } from "../interfaces";
import { Apollo, Notify } from "@/core/services";
import { UPDATE_POST_CODE } from "../graphql/Mutations";
import { useI18n } from "vue-i18n";
import InnerLoader from "@/components/InnerLoader.vue";

export default defineComponent({
	name: "edit site",
	components: {
		Input,
		InnerLoader,
	},

	setup() {
		const modal: any = ref();
		const loading = ref(false);
		const emitter: any = inject("emitter");
		const i18n = useI18n();
		const editPostCodeForm = ref<null | HTMLFormElement>(null);

		// Given Store Form Interface
		const postCodeUpdateData = ref<PostCodeUpdateFormData>({
			id: null,
			post_code_from: "",
			post_code_to: "",
		});

		// Submit Handler Request
		const submitHandlerForm = async () => {
			editPostCodeForm.value?.validate(async (valid: boolean) => {
				if (valid) {
					if (postCodeUpdateData.value.post_code_from > postCodeUpdateData.value.post_code_to) {
						Notify.error(`${i18n.t("message.FROM_SHOULD_BE_LESS_THAN_TO")}`);
						return;
					}
					loading.value = true;
					await Apollo.mutate({
						mutation: UPDATE_POST_CODE,
						variables: {
							id: postCodeUpdateData.value.id,
							from: postCodeUpdateData.value.post_code_from,
							to: postCodeUpdateData.value.post_code_to,
						},
						update: (store, { data: { update_post_code } }) => {
							modal.value.hide();
							loading.value = false;
							Notify.success(`${i18n.t("message.RECORD_UPDATED_SUCCESSFULLY")}`);
						},
					}).catch(() => {
						loading.value = false;
					});
				}
			});
		};

		// Reset Form Data On Model Popup
		const resetForm = () => {
			emitter.emit("clearInput");
			editPostCodeForm.value?.resetFields();
		};

		// Emitter To Open Model
		emitter.on("editPostCodeActions", (post_code: Record<any, any>) => {
			resetForm();
			postCodeUpdateData.value.id = post_code.id;
			postCodeUpdateData.value.post_code_from = post_code.from.toString();
			postCodeUpdateData.value.post_code_to = post_code.to.toString();

			modal.value = new Modal(document.getElementById("modal_edit_post_code")) as HTMLElement;
			modal.value.show();
		});

		return {
			loading,
			postCodeUpdateData,
			editPostCodeForm,
			submitHandlerForm,
		};
	},
});
